(ns minorodata.data-apps.api
  (:require [ajax.core :refer [json-request-format POST]]
            [ajax.protocols :as pr]
            [clojure.set :as c.set]
            [minorodata.app.api-config :refer [API_HOST]]
            [minorodata.app.utils :refer [save-buffer-to-file]]
            [minorodata.app.handlers :refer [dispatch reg-event-fx]]
            [minorodata.data-apps.model :refer [->data-app]]
            [mold-http.core :refer [reg-event-http]]
            [re-posh.core :as re-posh]))


;;
;; Fetch all data-apps
;;

(defn fetch-data-apps-request [_ _]
  {:http-xhrio
   {:id  :data-apps-fetch-request
    :url "/api/dashboards"}})

(defn fetch-data-apps-callback [_ [error resp]]
  (if (some? error)
    {:dispatch [:app.events/add-snack :error "Failed to load data apps"]}

    (let [previous-apps @(re-posh/subscribe [:data-app/pull])
          delete-previous-apps-events (mapv (fn [app-eid] [:data-app/delete app-eid])
                                            previous-apps)

          raw-new-apps (get-in resp [:result])
          apps         (map ->data-app raw-new-apps)]

      {:dispatch-n (conj delete-previous-apps-events
                         [:data-app/add-many apps])})))

(reg-event-http
 :data-apps.api/fetch-all
 fetch-data-apps-request
 fetch-data-apps-callback)


